export default {
    namespaced: true,
    state: {
        expand: true
    },
    getters: {
        isExpanded: (state) => state.expand
    },
    mutations: {
        toggleExpand(state) {
            const state$ = {...state};
            state.expand = !state$.expand;
        }
    }
}
